/* ------------------------------------------------------------------
   Cübe Quadros — rastreamento de favoritos (wishlist)
   Envia AddToWishlist pro Meta e add_to_wishlist pro GA4.

   Instalar como asset do tema e carregar DEPOIS do cube-favoritos.js:
     Online Store > Themes > Edit code > Assets > Add a new asset
     Nome: cube-favoritos-tracking.js
     Depois, no theme.liquid (antes de </body>):
     <script src="{{ 'cube-favoritos-tracking.js' | asset_url }}" defer></script>

   NÃO precisa mexer no cube-favoritos.js do Paulo.

   Regras:
   - Só dispara ao SALVAR. Remover não dispara (não suja o remarketing).
   - Funciona na página de produto (dado já está na página, sem requisição)
     e em coleção/home (busca /products/{handle}.js uma vez, com cache).
   - Testado em produção em 09/09/2026: 1 disparo ao salvar, 0 ao remover.
------------------------------------------------------------------ */
(function () {
  "use strict";
  if (window.CubeFavTracking) return;
  window.CubeFavTracking = true;

  var CACHE = {};

  // Sobe na árvore até achar o botão de favorito clicado
  function acharBotao(alvo) {
    for (var el = alvo; el && el !== document; el = el.parentNode) {
      if (el.getAttribute && el.getAttribute("data-fav-handle") !== null) return el;
    }
    return null;
  }

  // Página de produto: o Shopify já expõe tudo em window.meta
  function doMeta(handle) {
    try {
      var m = window.meta;
      if (m && m.page && m.page.pageType === "product" && m.product) {
        var p = m.product;
        var v = (p.variants && p.variants[0]) || {};
        var nome = v.name || "";
        if (v.public_title) nome = nome.replace(" - " + v.public_title, "");
        return {
          id: String(p.id),
          nome: nome || handle,
          preco: typeof v.price === "number" ? v.price / 100 : 0,
          categoria: p.type || "",
          marca: p.vendor || ""
        };
      }
    } catch (e) {}
    return null;
  }

  function vazio(handle) {
    return { id: handle, nome: handle, preco: 0, categoria: "", marca: "" };
  }

  // Coleção/home: busca o JSON do produto (1x por handle, fica em cache)
  function buscar(handle, cb) {
    var local = doMeta(handle);
    if (local) return cb(local);
    if (CACHE[handle]) return cb(CACHE[handle]);
    try {
      fetch("/products/" + handle + ".js")
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) {
          var d = j ? {
            id: String(j.id),
            nome: j.title || handle,
            preco: typeof j.price === "number" ? j.price / 100 : 0,
            categoria: j.product_type || "",
            marca: j.vendor || ""
          } : vazio(handle);
          CACHE[handle] = d;
          cb(d);
        })
        .catch(function () { cb(vazio(handle)); });
    } catch (e) {
      cb(vazio(handle));
    }
  }

  function enviar(handle, d) {
    // 1) Meta Ads — AddToWishlist é evento PADRÃO (serve pra público e otimização)
    try {
      if (typeof window.fbq === "function") {
        window.fbq("track", "AddToWishlist", {
          content_ids: [d.id],
          content_type: "product",
          content_name: d.nome,
          value: d.preco,
          currency: "BRL"
        });
      }
    } catch (e) {}

    // 2) GA4 — add_to_wishlist é evento recomendado, com items[]
    try {
      if (typeof window.gtag === "function") {
        window.gtag("event", "add_to_wishlist", {
          currency: "BRL",
          value: d.preco,
          items: [{
            item_id: d.id,
            item_name: d.nome,
            item_category: d.categoria,
            price: d.preco,
            quantity: 1
          }]
        });
      }
    } catch (e) {}

    // 3) Shopify Customer Events — deixa o custom pixel escutar depois (CAPI)
    //    Este é o ÚNICO caminho que atravessa o sandbox do pixel personalizado.
    try {
      if (window.Shopify && window.Shopify.analytics &&
          typeof window.Shopify.analytics.publish === "function") {
        window.Shopify.analytics.publish("cube_favorito_salvo", {
          handle: handle,
          productId: d.id,
          nome: d.nome,
          preco: d.preco,
          categoria: d.categoria,
          marca: d.marca,
          moeda: "BRL"
        });
      }
    } catch (e) {}
  }

  // Captura o clique no document. O cube-favoritos.js chama stopPropagation(),
  // mas isso NÃO impede outros listeners no mesmo nó — só a propagação adiante.
  // O setTimeout garante que a leitura aconteça depois do toggle, independente
  // da ordem em que os dois arquivos carregarem.
  document.addEventListener("click", function (ev) {
    var btn = acharBotao(ev.target);
    if (!btn) return;
    var handle = btn.getAttribute("data-fav-handle");
    if (!handle) return;
    setTimeout(function () {
      try {
        if (!window.CubeFavoritos || !window.CubeFavoritos.tem(handle)) return; // removeu → não dispara
        buscar(handle, function (d) { enviar(handle, d); });
      } catch (e) {}
    }, 0);
  }, true);
})();
